import MaterialUiSnackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import React from 'react';
const Snackbar = (props) => (React.createElement(MaterialUiSnackbar, Object.assign({ TransitionComponent: Slide, anchorOrigin: { vertical: 'top', horizontal: 'center' }, autoHideDuration: 3200 }, props)));
/**
 * @deprecated
 */
export default Snackbar;
